// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3YU2v","approved":"Status_approved__jRnA1","rejected":"Status_rejected__1F5t9","expired":"Status_expired__1ADaW","label":"Status_label__10mcR"};